import loadable from '@loadable/component';

export const PdfViewerLoadable = loadable(() => import('./PdfViewer'), {
  resolveComponent: (module) => module.PdfViewer,
  ssr: false,
});

/*export const PdfViewerLoadable = () => {
  return null;
};*/
